<template>
	<div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Movimiento</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
				<div class="form-inline">
					<label>
						<input 
							v-model="form.tipoDocumento" 
							type="radio" 
							value="ND"
							@change="changeTipoDocumento"
						>
						<span>Nota de Débito</span>
					</label>
					<label>
						<input 
							v-model="form.tipoDocumento" 
							type="radio" 
							value="NC"
							@change="changeTipoDocumento"
						>
						<span>Nota de Crédito</span>
					</label>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field select2">
					<div class="select2-field">
						<v-select
							placeholder="Seleccione..."
							@input="inputMotivo"
							id="motivo"
							v-model="selectedMotivo"
							:options="motivos"
							label="descripcion"
						></v-select>
						<label for="motivo">Motivo</label>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div
					class="form-field select2"
				>
					<div class="select2-field">
						<v-select
							@search="onSearchRutas"
							@input="inputRuta"
							id="ruta"
							v-model="selectedRuta"
							:options="rutas"
							label="descripcion"
							placeholder="Seleccione..."
						></v-select>
						<label for="ruta">Ruta</label>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field">
					<div class="datepicker-field">
						<VueCtkDateTimePicker 
							id="fecha"
							v-model="form.fecha"
							locale="es"
							no-label
							button-now-translation="Ahora"
							format="YYYY-MM-DD HH:mm"
							formatted="YYYY-MM-DD HH:mm"
							label="Seleccione fecha..."
						/>
						<label>Fecha</label>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field">
					<input-field
						id="observacion"
						v-model="form.observacion"
						placeholder=""
					>
						Observación
					</input-field>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field">
					<input-field
						id="valor"
						v-model="form.valor"
						placeholder="Escriba un valor..."
						vMoney
            :format="money"
					>
						Valor
					</input-field>
				</div>
			</div>
		</div>
		<div class="modal-buttons">
      <button
        type="button"
        @click="$emit('cerrar')"
        class="btn-danger btn--text"
      >
        <i class="fa fa-ban"></i><span>Cancelar</span>
      </button>
			<button
        type="button"
        @click="guardar"
        class="btn-success"
      >
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
    </div>
	</div>
</template>

<script>
export default {
	props: {
		pedidoId: {
			required: true,
		}
	},
	data: function () {
		return {
			money,
			selectedMotivo: null,
			selectedRuta: null,
			todosMotivos: [],
			motivos: [],
			form: {
				tipoDocumento: 'ND',
				fecha: moment(new Date()).format("YYYY-MM-DD HH:mm"),
				motivo_id: null,
				motivo_descripcion: '',
				observacion: '',
				valor: 0,
				ruta_id: '',
				ruta: ''
			},
			rutas: []
		}
	},
	methods: {
		inputRuta: function () {
			if (this.selectedRuta != null) {
				this.form.ruta_id = this.selectedRuta.id;
			} else {
				this.form.ruta_id = "";
			}
			this.form.ruta = this.selectedRuta != null?this.selectedRuta.nombre:'';
		},
		onSearchRutas: function (search, loading) {
			loading(true);
			let that = this;
			let xmlhttp = new XMLHttpRequest();
			xmlhttp.onreadystatechange = function () {
				if (
				(this.readyState == 4 && this.status == 200) ||
				this.status == 201
				) {
				let json = JSON.parse(this.responseText);
				that.rutas = json;
				loading(false);
				} else loading(false);
			};
			xmlhttp.open(
				"GET",
				url + "/search/rutas?search=" + search,
				true
			);
			xmlhttp.send();
		},
		inputMotivo: function() {
			let motivo = this.selectedMotivo;
			if(motivo != null){
				this.form.motivo_id = motivo.id;
				this.form.motivo_descripcion = motivo.descripcion;
			}
			else{
				this.form.motivo_id = null;
				this.form.motivo_descripcion = "";
			}
		},
		changeTipoDocumento: function() {
			this.form.motivo_id = null;
			this.motivos.splice(0, this.motivos.length);
			this.selectedMotivo = null;
			let tipoDocumento = this.form.tipoDocumento;
			this.todosMotivos.forEach(motivo => {
				if((tipoDocumento == 'ND' && motivo.tipo == 'D') || (tipoDocumento == 'NC' && motivo.tipo == 'C'))
					this.motivos.push(motivo);
			});
		},
		validarFormulario: function() {
			if(this.form.tipoDocumento == null || this.form.tipoDocumento == ''){
				swal('Aviso', 'Debe seleccionar un tipo de documento', 'warning');
				return false;
			}
			if(this.form.fecha == null){
				swal('Aviso', 'Debe seleccionar una fecha', 'warning');
				return false;
			}
			if(this.form.motivo_id == null || this.selectedMotivo == null){
				swal('Aviso', 'Debe seleccionar un motivo', 'warning');
				return false;
			}
			if(this.form.observacion.length > 255){
				swal('Aviso', 'La observación no puede pasar de 255 caracteres', 'warning');
				return false;
			}
			if (this.selectedRuta == null) 
			{
				swal('Aviso', 'La ruta es requerida', 'warning');
				return false;
			}
			let valor = parseFloat(this.form.valor);
			if(isNaN(valor))
				valor = 0;
			if(valor <= 0){
				swal('Aviso', 'Debe ingresar un valor mayor a cero');
				return false;
			}
			return true;
		},
		guardar: function() {
			if(!this.validarFormulario())
				return;
			this.$emit('guardar', this.form);
		},
		cargarFormulario: function() {
			let urlApi = `${url}/motivo/obtener/motivos`;
			axios
				.get(urlApi)
				.then(response => {
					let data = response.data;
					let motivos = [...data.motivos];
					motivos.forEach(motivo => {
						if(motivo.tipo == 'D')
							this.motivos.push(motivo);
					});
					this.todosMotivos = [...data.motivos];
				})
				.catch(error => {
					swal.fire('Error', 'No se pudo cargar los motivos', 'error');
				});
		},	
	},
	mounted: function() {
		this.cargarFormulario();
	},
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/NotaDebitoCredito.vue